import { render } from "./SentMail.vue?vue&type=template&id=4515c2ea&scoped=true"
import script from "./SentMail.vue?vue&type=script&lang=js"
export * from "./SentMail.vue?vue&type=script&lang=js"

import "./SentMail.vue?vue&type=style&index=0&id=4515c2ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4515c2ea"]])

export default __exports__